<template>
  <v-btn
    depressed
    :x-small="xSmall"
    :small="small"
    :large="large"
    :x-large="xLarge"
    :outlined="outlined"
    :loading="loading"
    :color="color"
    :disabled="disabled"
    :height="height"
    class="rounded-lg px-7 py-2 app-btn"
    :block="block"
    :class="!outlined ? 'white--text' : ''"
    @click="e => $emit('click', e)"
    v-bind="vbind"
    v-on="von"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'AppBtn',

  props: {
    xSmall: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },

    large: {
      type: Boolean,
      default: false,
    },

    xLarge: {
      type: Boolean,
      default: false,
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: 'primary'
    },

    block: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String | Number,
      default: undefined
    },
    vbind: {
        type: Object,
        default: undefined
    },
    von: {
        type: Object,
        default: undefined
    },
  }
}
</script>

<style scoped>
.app-btn {
  text-transform: none;
  letter-spacing: normal;
  font-size: 20px;
  font-weight: bold;
}
</style>